import type {
  ModularBilling2026SubscriptionAccessResponseBodyType,
  OrganizationSummaryDto,
  StripeSubscriptionSummaryDto,
} from "@intelligems/ig-types";
import {
  committedEntityIds,
  heldEntityIds,
} from "@src/components/BillingSettings2026/workflow";
import { isModularOrganizationSummary } from "@src/utils/modular-billing-organization";

export type ShopifyBillingRoute =
  | { kind: "picker"; selectedEntityIds: string[] }
  | { kind: "legacy-approval"; subscriptionLink: StripeSubscriptionSummaryDto }
  | { kind: "none" };

/**
 * The legacy approval paths mint a Shopify charge outside the billing
 * workflow, so an org whose modularity is unknown is treated as modular and
 * never reaches them.
 */
export const resolveShopifyBillingRoute = ({
  subscriptionAccess,
  orgSummary,
  missingBilling,
}: {
  subscriptionAccess:
    | ModularBilling2026SubscriptionAccessResponseBodyType
    | undefined;
  orgSummary: OrganizationSummaryDto | undefined;
  missingBilling: StripeSubscriptionSummaryDto | null | undefined;
}): ShopifyBillingRoute => {
  const isModular =
    subscriptionAccess?.org.isModular ??
    (orgSummary ? isModularOrganizationSummary(orgSummary) : true);

  if (isModular) {
    const planCommitment =
      orgSummary?.planCommitment ?? subscriptionAccess?.planCommitment;
    return {
      kind: "picker",
      selectedEntityIds: planCommitment
        ? committedEntityIds(planCommitment)
        : subscriptionAccess
          ? heldEntityIds(subscriptionAccess)
          : [],
    };
  }
  return missingBilling?.id
    ? { kind: "legacy-approval", subscriptionLink: missingBilling }
    : { kind: "none" };
};
